import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', href: '/' },
    { label: '专注之道', href: '/category/zhuanzhu-zhidao' },
    { label: '目标管理', href: '/category/mubiao-guanli' },
    { label: '人生哲学', href: '/category/rensheng-zhexue' },
    { label: '心路历程', href: '/category/xinlu-licheng' },
    { label: '关于我们', href: '/about' },
  ],
  philosophy: [
    { label: '心无旁骛', href: '/category/zhuanzhu-zhidao' },
    { label: '专注目标', href: '/category/mubiao-guanli' },
    { label: '走稳每一步', href: '/category/rensheng-zhexue' },
    { label: '专一之道', href: '/category/zhuanzhu-zhidao' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50" role="contentinfo">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="font-display text-2xl font-semibold text-background-50 hover:text-background-200 transition-colors duration-200">
              一本道
            </Link>
            <p className="mt-4 text-sm text-background-200 leading-relaxed max-w-xs">
              专注于正道、专一、坚定前行的人生成长理念。
              心无旁骛，走稳每一步，与志同道合者共同践行专一之道。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              <a href="/category" className="hover:text-background-200 transition-colors duration-200">内容导航</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-200 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              核心理念
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.philosophy.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-200 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-300">
            &copy; {new Date().getFullYear()} 一本道 · 专注正道人生成长平台。保留所有权利。
          </p>
          <p className="text-xs text-background-300">
            心无旁骛 · 专注目标 · 走稳每一步
          </p>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '一本道',
            url: 'https://yibendao.cn',
            description: '一本道，专注于正道、专一、坚定前行的人生成长理念。',
            sameAs: [],
          }),
        }}
      />
    </footer>
  );
}